module.exports = {"421022100":"埠河镇","421022101":"斗湖堤镇","421022102":"夹竹园镇","421022103":"闸口镇","421022104":"杨家厂镇","421022105":"麻豪口镇","421022106":"藕池镇","421022107":"黄山头镇","421022108":"孟家溪镇","421022109":"南平镇","421022110":"章庄铺镇","421022111":"狮子口镇","421022112":"斑竹垱镇","421022113":"毛家港镇","421022200":"甘家厂乡","421022201":"章田寺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421022.json
// module id = 1888
// module chunks = 0